import React from 'react';

import '../css/nft.css';

const NFT = ({onChange, onSubmit}) => {

    const handleChange = (event) => {
        const name = event.target.name;
        const value = event.target.value;
        onChange(name, value);
    }

    return (
        <div className="center">
            <form className="nft-form flex-container" onSubmit={onSubmit}>
                <h1 className="body-large bold title">
                    Qualification form
                </h1>
                {/* <p className="question content">The Investor is a natural person (an individual) whose own
                net worth, taken together with the net workth of the Investor's spouse, exceeds $1,000,000. Net worth 
                for this purpose means total assets (residence, person property and other assets) in excess of total liabilities.</p>
                <div className="radio-container" onChange={handleChange}>
                    <label className="nft-form-label" htmlFor="one" >Yes</label>
                    <input type="radio" name="one" value="yes" className="nft-form-input" />
                    <label className="nft-form-label" htmlFor="one" >No</label>
                    <input type="radio" name="one" value="no" className="nft-form-input" />
                </div>
                <p className="question content">The Investor is a natural person (an individual) who had an individual gross income in 
                excess of $200,000 in each of the two most recent years, or a joint income with the Investor's spouse in 
                excess of $300,000 in each of the two most recent years, and reasonably expects to have the same 
                income level in the current year.</p>
                <div className="radio-container" onChange={handleChange}>
                    <label className="nft-form-label" htmlFor="two" >Yes</label>
                    <input type="radio" name="two" value="yes" className="nft-form-input" />
                    <label className="nft-form-label" htmlFor="two" >No</label>
                    <input type="radio" name="two" value="no" className="nft-form-input" />
                </div>
                <p className="question content">The Investor is an organization described in Section 501(c)(3) of the Internal Revenue Code,
                or a corporation, partnershop or trust, with total assets in excess of $5,000,000, not formed for the specific
                 purpose of acquriring the Shares offered, and, in the case of any trust, whose purchase is directed by a 
                person with such knowledge and experience in financial and business matters that he is capable of 
                evaluating the merits and risks of the prospective investment.</p>
                <div className="radio-container" onChange={handleChange}>
                    <label className="nft-form-label" htmlFor="three" >Yes</label>
                    <input type="radio" name="three" value="yes" className="nft-form-input" />
                    <label className="nft-form-label" htmlFor="three" >No</label>
                    <input type="radio" name="three" value="no" className="nft-form-input" />
                </div>
                <p className="question content">The Investor is a plan established and maintained by a State, 
                its political subdivisions, or an agency or instrumentalality of a State or its 
                political subdivisions, for the benefit of its employees, and has a total 
                assets in excess of $5,000,000.</p>
                <div className="radio-container" onChange={handleChange}>
                    <label className="nft-form-label" htmlFor="four" >Yes</label>
                    <input type="radio" name="four" value="yes" className="nft-form-input" />
                    <label className="nft-form-label" htmlFor="four" >No</label>
                    <input type="radio" name="four" value="no" className="nft-form-input" />
                </div>
                <p className="question content">The Investor is an employee benefit plan with the mean of the Employee 
                Retirement Income Security Act of 1974 and either (a) the investment decision is 
                made by a plan fiduciary, as defined in Section 3(21) of such Act, which is either 
                a bank, savings and loan association, insurance company, or registered investment 
                advisor, or (b) the plan has total assets in excess of $5,000,000.</p>
                <div className="radio-container" onChange={handleChange}>
                    <label className="nft-form-label" htmlFor="five" >Yes</label>
                    <input type="radio" name="five" value="yes" className="nft-form-input" />
                    <label className="nft-form-label" htmlFor="five" >No</label>
                    <input type="radio" name="five" value="no" className="nft-form-input" />
                </div>
                <p className="question content">The Investor is a broker or dealer registered pursuant to the 
                Securities Exchange Act of 1934.</p>
                <div className="radio-container" onChange={handleChange}>
                    <label className="nft-form-label" htmlFor="six" >Yes</label>
                    <input type="radio" name="six" value="yes" className="nft-form-input" />
                    <label className="nft-form-label" htmlFor="six" >No</label>
                    <input type="radio" name="six" value="no" className="nft-form-input" />
                </div>
                <p className="question content">The Investor is an investment company registered under 
                the Investment Company Act 1940, a business developement company as defined in Section 2(a)(48) 
                of that Act or any Small Business Investment Company licensed by the U.S. Small 
                Business Administration under section 301(c) or 301(d) of the Small Business Investment 
                Act of 1958.</p>
                <div className="radio-container" onChange={handleChange}>
                    <label className="nft-form-label" htmlFor="seven" >Yes</label>
                    <input type="radio" name="seven" value="yes" className="nft-form-input" />
                    <label className="nft-form-label" htmlFor="seven" >No</label>
                    <input type="radio" name="seven" value="no" className="nft-form-input" />
                </div>
                <p className="question content">The Investor is a private business developement company as defined 
                in Section 202(a)(22) of the Investment Advisers Act of 1940.</p>
                <div className="radio-container" onChange={handleChange}>
                    <label className="nft-form-label" htmlFor="eight" >Yes</label>
                    <input type="radio" name="eight" value="yes" className="nft-form-input" />
                    <label className="nft-form-label" htmlFor="eight" >No</label>
                    <input type="radio" name="eight" value="no" className="nft-form-input" />
                </div>
                <p className="question content">The Investor is a grantor trust with new worth of more than $1,000,000. Net 
                worth for this purpose means total assets in excess of total liabilities.</p>
                <div className="radio-container" onChange={handleChange}>
                    <label className="nft-form-label" htmlFor="nine" >Yes</label>
                    <input type="radio" name="nine" value="yes" className="nft-form-input" />
                    <label className="nft-form-label" htmlFor="nine" >No</label>
                    <input type="radio" name="nine" value="no" className="nft-form-input" />
                </div>
                <p className="question content">The Investor is a corporation, partnership, trust or other entity, 
                all of whose equity owners are Accredited Investors under any of the foregoing or 
                otherwise an Accredited Investor within the meaning of Regulation D promulgated under 
                the Securities Act of 1933.</p>
                <div className="radio-container" onChange={handleChange}>
                    <label className="nft-form-label" htmlFor="ten" >Yes</label>
                    <input type="radio" name="ten" value="yes" className="nft-form-input" />
                    <label className="nft-form-label" htmlFor="ten" >No</label>
                    <input type="radio" name="ten" value="no" className="nft-form-input" />
                </div>
                <p className="question content">The Investor is a corporation, Massachusetts business trust or 
                similar business trust or partnership, not formed with the specific purpose of acquriring the 
                securities offered, with total assets of in excess of $5,000,000.</p>
                <div className="radio-container" onChange={handleChange}>
                    <label className="nft-form-label" htmlFor="one" >Yes</label>
                    <input type="radio" name="eleven" value="yes" className="nft-form-input" />
                    <label className="nft-form-label" htmlFor="one" >No</label>
                    <input type="radio" name="eleven" value="no" className="nft-form-input" />
                </div> */}
                <p className="question content">
                    Do you, the Investor, qualify as one of the following?
                    <br></br>
                    <br></br>
                    A natural person (an individual) whose own net worth, taken together with the net worth of the Investor's spouse, exceeds $1,000,000. Net worth for this purpose means total assets (residence, person property and other assets) in excess of total liabilities.
                    <br></br>
                    <br></br>
                    A natural person who had an individual gross income in excess of $200,000 in each of the two most recent years, or a joint income with the Investor's spouse in excess of $300,000 in each of the two most recent years, and reasonably expects to have the same income level in the current year.
                </p>
                <div className="radio-container" onChange={handleChange}>
                    <input type="radio" name="twelve" value="yes" className="nft-form-input" />
                    <label className="nft-form-label" htmlFor="one" >Yes</label>
                    <input type="radio" name="twelve" value="no" className="nft-form-input" />
                    <label className="nft-form-label" htmlFor="one" >No</label>
                </div>
                <div className="handles">
                    <p className="question content">We'd like to get to know you better:</p>
                    <div className='inputs'>
                        <input className="handles-input" type="text" value="Twitter handle (optional)"></input>
                        <input className="handles-input" type="text" value="AngelList (optional)"></input>
                    </div>
                </div>
                <input type="submit" value="Next step: Pay fee" className="submit-btn pink-btn" />
            </form>
        </div>
    );
}

export default NFT;